export function encodeHtmlToBase64(html) {
    // Convert HTML to a UTF-8 encoded byte array
    const utf8Bytes = new TextEncoder().encode(html);
    
    // Convert the byte array to a Base64 string
    const base64String = btoa(String.fromCharCode.apply(null, utf8Bytes));
    
    return base64String;
  }